import { render, staticRenderFns } from "./AccountManagementMainHeader.vue?vue&type=template&id=c99fdf54&scoped=true&"
import script from "./AccountManagementMainHeader.vue?vue&type=script&lang=ts&"
export * from "./AccountManagementMainHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c99fdf54",
  null
  
)

export default component.exports